import { Skeleton, Table } from 'antd'
import React from 'react'

function TableSkeleton() {
    const columns = [
        { title: 'Surveyor', dataIndex: 'name', key: 'name' },
        { title: 'Category', dataIndex: 'category', key: 'category' },
        { title: 'State', dataIndex: 'state', key: 'state' },
        { title: 'District', dataIndex: 'district', key: 'district' },
        { title: 'City', dataIndex: 'city', key: 'city' },
        { title: 'Status', dataIndex: 'status', key: 'status' },
        { title: 'Total Surveys', dataIndex: 'totalSurveys', key: 'totalSurveys' },
        { title: 'Action', key: 'action' },
      ];
  
      const data = Array(2).fill(null).map((_, index) => ({
        key: index,
        name: <Skeleton.Avatar active size="small" shape="circle" />,
        category: <Skeleton.Input style={{ width: 100 }} active size="small" />,
        state: <Skeleton.Input style={{ width: 100 }} active size="small" />,
        district: <Skeleton.Input style={{ width: 100 }} active size="small" />,
        city: <Skeleton.Input style={{ width: 100 }} active size="small" />,
        status: <Skeleton.Input style={{ width: 100 }} active size="small" />,
        totalSurveys: <Skeleton.Input style={{ width: 50 }} active size="small" />,
        action: <Skeleton.Button active size="small" />,
      }));
  return (
    <>
    <Table
      columns={columns}
      dataSource={data}
      pagination={false}
      className="custom-table-header lg:w-full w-[250px] overflow-auto custom-pagination"
    />
    <div className="mt-4 flex justify-between items-center">
      <Skeleton.Input style={{ width: 200 }} active size="small" />
      <div>
        <Skeleton.Button active size="small" style={{ marginRight: 8 }} />
        <Skeleton.Button active size="small" style={{ marginRight: 8 }} />
        <Skeleton.Button active size="small" />
      </div>
    </div>
  </>
  )
}

export default TableSkeleton